import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import { theme } from "./styles/muiTheme";
import { RouterProvider } from "react-router-dom";
import { router } from "./routing/router";
import { Provider } from "react-redux";
import { store } from "./store";
import './styles/fonts.css';
import { CookieNotify } from "components/CookieNotify";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <RouterProvider router={router} />

        <CookieNotify />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
